<mat-form-field>
  <mat-label>Производители</mat-label>
  <mat-select [formControl]="control" multiple>
    <mat-option *ngFor="let brand of allBrands" [value]="brand">{{ brand.description }}</mat-option>
  </mat-select>
</mat-form-field>
